<template>
  <div class="input_container">
    <van-field v-model="inputValue"
      :style="{ border: props.isShowError ? '1.5px red solid' : '0.5px solid #65436f' }"
      type="text" :placeholder="props.labelText">
      <template #right-icon>
        <div style="display: flex; align-items: center; justify-content: right;">
          <img  :src="captchaImg" alt="" width="90%" class="iconImage" @click="updateCaptcha"/>
        </div>
      </template>
    </van-field>
  </div>
</template>

<script setup lang="ts">
import { defineProps, ref, watch, defineEmits } from 'vue'

const props = defineProps({
  labelText: {
    type: String,
    default: () => ''
  },
  isShowError: {
    type: Boolean,
    default: () => false
  },
  captchaImg :{
     type: String,
  }
})

const isShow = ref(false)
const inputValue = ref('')

const emit = defineEmits(['valueChanged', 'updateCaptcha'])


watch(() => inputValue.value, (newValue: string) => {
  emit('valueChanged', newValue)
});

const updateCaptcha = () => {
  console.log("click")
    emit('updateCaptcha') 
}

</script>
<style scoped>
.input_container>>>.van-field {
  border-radius: 10px;
  background: #2c1d31;
  /* border: 0.5px solid rgba(221, 122, 51, 0.5); */
  color: #ffffffd9;
  padding: 4px 15px !important;
  margin-top: 10px;
  font-size: 17px;


}

.input_container>>>.van-field__control {
  color: #fff !important;
  padding-left: 10px !important;
}

.input_container>>>.van-field__control::placeholder {
  color: #ffffff40 !important;
  font-family: monospace;
}

.input_container>>>.van-field__right-icon {
  color: #ffffff40 !important;
  padding-right: 5%;
  width: 30%;
}

.leftContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.currencyText {
  color: #ffffffa6;
  font-family: monospace;
  padding: 0 5px;
  margin: 0;
}

.leftContainer img {
  width: 25px;
}

.line {
  width: 1px;
  background-color: rgba(255, 255, 255, 0.65);
  height: 15px;
  margin-right: 5px;
}
.iconImage{
  padding: 2px;
}
</style>